import Modal from "../../../components/common/form/Modal";
import React, {ChangeEvent, useEffect, useState} from "react";
import {
    createOptionListForSelectTag,
    removeInvalidAndTrimList,
    setNestedValue,
    showToast
} from "../../../helpers/utils/Utils";
import SelectField from "../../../components/common/form/SelectField";
import {useGetAllRegularCustomersQuery} from "../../customer/customerApi";
import {useLazyGetBranchesForCustomerQuery} from "../../customer/branchApi";
import ButtonTray from "../../../components/common/form/ButtonTray";
import InputField from "../../../components/common/form/InputField";
import {readSheet} from "read-excel-file/browser";
import Form from "../../../components/common/form/Form";
import {useSubmitImportedOrderMutation} from "../../../app/utilityRequestsApi";

interface Props {
    show: boolean;
    setShow: any;
}


const OrderSpreadSheetImportModel: React.FC<Props> = ({show, setShow}) => {

    const allRegularCustomersResult = useGetAllRegularCustomersQuery("");
    const [getBranchesForCustomer, branchesForCustomerResult,] = useLazyGetBranchesForCustomerQuery();
    const [responseArray, setResponseArray] = useState([]);
    const [fileDataList, setFileDataList] = useState<any>([]);
    const [data, setData] = useState<any>();
    const [createOrderResponse, setCreateOrderResponse] = useState([]);
    const [disable, setDisable] = useState(false);
    const [submitImportedOrder] = useSubmitImportedOrderMutation();


    useEffect(() => {
        if (data?.customerId) {
            getBranchesForCustomer({pageSize: 100, customerId: data.customerId?.value})
        }
    }, [data?.customerId]);

    useEffect(() => {
        if (responseArray && Array.isArray(responseArray) && responseArray.length > 0) {
            setCreateOrderResponse(responseArray);
        }
    }, [responseArray]);

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        const inputOrderList = getOrderInputObjList(fileDataList);

        setDisable(true);
        for (let i = 0; i < inputOrderList.length; i++) {
            let createOrderDefaultErrorResponse: any = {}

            await submitImportedOrder(inputOrderList[i]).unwrap().then((handledRes: any) => {

                if (handledRes.success === true) {

                    // @ts-ignore
                    setResponseArray((previousState: any) => {
                        return [...previousState, handledRes]
                    });

                } else {

                    createOrderDefaultErrorResponse.message = handledRes.message;
                    createOrderDefaultErrorResponse.sequenceNumber = inputOrderList[i].sequenceNumber;

                    // @ts-ignore
                    setResponseArray((previousState: any) => {
                        return [...previousState, createOrderDefaultErrorResponse]
                    });
                }

            }).catch((error: any) => {
                createOrderDefaultErrorResponse.message = error?.data?.message || error?.message || "Internal server error!";
                createOrderDefaultErrorResponse.sequenceNumber = inputOrderList[i].sequenceNumber;

                // @ts-ignore
                setResponseArray((previousState: any) => {
                    return [...previousState, createOrderDefaultErrorResponse]
                });

            })

        }

        setDisable(false);
        return {
            errorCode: 200, data: responseArray, message: "Success", success: true,
        };
    }


    function getOrderInputObjList(fileDataList: any) {

        let inputOrderList = [];

        for (let i = 0; i < fileDataList.length; i++) {

            let prop = [];

            let obj = {
                sequence: 1,
                address: {
                    streetAddress: fileDataList[i]['Address_Line_1'],
                    city: fileDataList[i]['City'],
                    state: fileDataList[i]['State'],
                    zip: fileDataList[i]['Zipcode']
                },
                countyName: fileDataList[i]['County'],
                propertyRequestSource: "CUSTOMER",
                propertyType: "RESIDENTIAL",
                accountNumber: fileDataList[i]['Parcel_ID']
            };

            prop.push(obj);

            const inputOrderObj = {
                sequenceNumber: fileDataList[i]['sequenceNumber'],
                orderNumber: fileDataList[i]['Order_Number'],
                sellers: removeInvalidAndTrimList([fileDataList[i]['Seller_Last_Name'], fileDataList[i]['Seller_First_Name']]),
                customerId: data?.customerId?.value,
                branchId: data?.branchId?.value,
                properties: prop,
                products: ['TAX_CERTIFICATE']
            }

            inputOrderList.push(inputOrderObj);
        }

        return inputOrderList;
    }


    const handleOnChange = (
        e: ChangeEvent<HTMLInputElement> | { name: string; value: string }
    ) => {
        const {name, value} = "target" in e ? e.target : e;

        setData((prevData: any) => {
            const updated = setNestedValue(prevData, name.split("."), value);

            // if top-level key is customerId, reset branchId
            const isCustomerChange = name === "customerId";

            return {
                ...prevData,
                ...updated,
                ...(isCustomerChange && {branchId: null}),
            };
        });
    };

    function dismissModal(e: React.FormEvent) {
        e.preventDefault();
        setFileDataList([]);
        setCreateOrderResponse([]);
        setResponseArray([]);
        setShow(false);
    }

    function createOrdersStatus(sequenceNumber: any) {

        let returnVal = createOrderResponse.find((cur: any) => cur.sequenceNumber !== null && cur.sequenceNumber.toString().trim() === sequenceNumber.toString().trim());

        if (returnVal === null || returnVal === undefined) {
            return {
                success: true,
                message: "loading!",
                sequenceNumber: null,
                className: "disableSelection fa fa-spin fa-sync large_icon ml-2"
            }
        }

        // @ts-ignore
        returnVal.className = returnVal.success ? "fa fa-check-circle ml-2 text-text-5" : "fa fa-times-circle ml-2 text-error-1";
        return returnVal;
    }

    async function handleBulkOrderFileUpload(event: React.ChangeEvent<HTMLInputElement>) {
        // resetState();

        const file = event.target.files?.[0];

        // Validate file type
        if (!file || !isExcelFile(file)) {
            showToast("Uploaded file should be an XLSX file!", "warning");
            return;
        }

        try {
            const excelData = await readSheet(file);
            const dataList = excelData.filter(row => row.length > 0);
            const headers = dataList[0]?.map(value => String(value ?? "")) ?? [];

            const isValidFile = validationForOrderFile(headers);

            if (!isValidFile) {
                setFileDataList([]);
                showToast("Uploaded file is not of the correct format!", "warning");
            } else {
                const jsonArray: any = dataList.slice(1).map((row, index) => {
                    const jsonObject: any = {sequenceNumber: index + 1};

                    headers.forEach((header, i) => {
                        const propertyName = header.replace(/ /g, "_");
                        jsonObject[propertyName] = row[i];
                    });

                    return jsonObject;
                });

                setFileDataList(jsonArray);
            }
        } catch {
            setFileDataList([]);
            showToast("Unable to read the uploaded XLSX file!", "warning");
        }
    }

    function isExcelFile(file: File) {
        const xlsxMimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        return file.type === xlsxMimeType || file.name.toLowerCase().endsWith(".xlsx");
    }

    function validationForOrderFile(headers: any) {

        // check header exists or not
        if (!headers) {
            return false;
        }

        // Define the expected header values
        const expectedHeaders = ['Order Open Date', 'Order Number', 'Seller Last Name', 'Seller First Name', 'Address Line 1', 'City', 'State', 'Zipcode', 'County', 'Parcel ID'];

        // Check if all the expected headers are present in the file headers
        return expectedHeaders.every((expectedHeader) => headers.includes(expectedHeader));
    }

    function getValidText(value: any) {
        if (value === undefined) {
            return "";
        }
        return value;
    }

    function removeOrderFromImportGrid(e: any, sequenceNumber: any) {
        e.preventDefault();
        const updatedFilesDate = fileDataList.filter((fileData: any) => fileData !== null && fileData.sequenceNumber !== sequenceNumber);
        setFileDataList(updatedFilesDate);
    }


    return (
        <>
            <Modal
                title={"Order Spread Sheet Importer"}
                show={show}
                setShow={setShow}
                className="w-3/6  bg-text-0 rounded-lg shadow-lg"
                fields={
                    <Form onSubmit={handleSubmit} fields={
                        <>
                            <SelectField
                                label="Customer"
                                value={data?.customerId}
                                placeholder="Select Customer..."
                                options={createOptionListForSelectTag(allRegularCustomersResult?.data?.filter((el: any) => !el.parentCustomer), "customerName", "id", "customerNumber")}
                                onChange={(selectedOption: any) => handleOnChange({
                                    name: 'customerId',
                                    value: selectedOption
                                })}
                                required={true}
                            />

                            <SelectField
                                label="Branch"
                                value={data?.branchId}
                                placeholder="Select Branch..."
                                options={createOptionListForSelectTag(branchesForCustomerResult?.data?.data, "name", "id", "", "displayLabel")}
                                onChange={(selectedOption: any) => handleOnChange({
                                    name: 'branchId',
                                    value: selectedOption
                                })}
                                required={true}
                                isLoading={branchesForCustomerResult.isFetching}
                            />


                            <InputField className="form-control file-field"
                                        type="file" name="file"
                                        onChange={handleBulkOrderFileUpload}
                                        id={"doc" + data?.fileId}
                                        disabled={(responseArray && Array.isArray(responseArray) && responseArray.length > 0)}
                                        accept={".xlsx"}
                                        label={"Select File"}
                                        required={true}
                            />


                            {fileDataList && Array.isArray(fileDataList) && fileDataList.length > 0 &&
                                <div className={"mt-4 table-responsive table_data"}>
                                    <table className={'order_table_Wrapper min-w-full mt-5 table-auto'}>
                                        <thead>
                                        <tr>
                                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>Action</th>
                                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>Order
                                                No.
                                            </th>
                                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>Seller</th>
                                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>City</th>
                                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>County</th>
                                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>Address</th>
                                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>Zip</th>
                                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>Parcel</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {fileDataList && Array.isArray(fileDataList) && fileDataList.length > 0 && fileDataList.map((data: any, index: number) => {
                                            return <tr key={index}>
                                                <td className={"border border-surface-5 text-surface-0"}>
                                                    <div className={"d-flex"}
                                                         title={Array.isArray(createOrderResponse) && createOrderResponse.length > 0 && createOrdersStatus(data?.sequenceNumber)?.message || "Internal server error!"}>
                                                        <i className={"fa fa-trash mr-2 text-highlight-0"}
                                                           onClick={(e) => removeOrderFromImportGrid(e, data?.sequenceNumber)}/>
                                                        {/*// @ts-ignore*/}
                                                        <i className={Array.isArray(createOrderResponse) && createOrderResponse.length > 0 && createOrdersStatus(data?.sequenceNumber)?.className}/>
                                                    </div>
                                                </td>
                                                <td className={"border border-surface-5 text-surface-0"}>{getValidText(data.Order_Number)}</td>
                                                <td className={"border border-surface-5 text-surface-0"}>{getValidText(data.Seller_First_Name) + " " + getValidText(data.Seller_Last_Name)}</td>
                                                <td className={"border border-surface-5 text-surface-0"}>{getValidText(data.City)}</td>
                                                <td className={"border border-surface-5 text-surface-0"}>{getValidText(data.County) + ", " + getValidText(data.State)}</td>
                                                <td className={"border border-surface-5 text-surface-0"}>{getValidText(data.Address_Line_1)}</td>
                                                <td className={"border border-surface-5 text-surface-0"}>{getValidText(data.Zipcode)}</td>
                                                <td className={"border border-surface-5 text-surface-0"}>{getValidText(data.Parcel_ID)}</td>
                                            </tr>
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            }


                            <div className="mt-4 border-t border-t-surface-5 flex justify-end">
                                {Array.isArray(createOrderResponse) && createOrderResponse.length > 0 && createOrderResponse.length === fileDataList.length
                                    ? <ButtonTray
                                        buttons={[
                                            {
                                                buttonProps: {
                                                    btnText: "Continue",
                                                    onClick: dismissModal,
                                                    type: "close",
                                                },
                                                buttonType: "button"
                                            }
                                        ]}
                                        align={"end"}
                                        gap={2}
                                    /> : <ButtonTray
                                        buttons={[
                                            {
                                                buttonProps: {
                                                    btnText: "Cancel",
                                                    onClick: dismissModal,
                                                    type: "close",
                                                },
                                                buttonType: "button"
                                            },
                                            {
                                                buttonProps: {
                                                    btnText: "Submit",
                                                    type: "submit",
                                                    isLoading: disable,
                                                    isDisabled: disable
                                                },
                                                buttonType: "button",
                                            }
                                        ]}
                                        align={"end"}
                                        gap={2}
                                    />
                                }

                            </div>
                        </>
                    }/>

                }
            />
        </>
    )
}
export default OrderSpreadSheetImportModel;
